import type { ReportRow } from "../../../api/types/widgetTypes";

const rowMatchesSearch = (row: ReportRow, searchTerm: string): boolean =>
  Object.values(row.cells).some(
    (cellValue) =>
      (cellValue.valueType === "String" || cellValue.valueType === "Unknown") &&
      cellValue.formattedValue.toLowerCase().includes(searchTerm)
  );

export const searchTabularReportRows = (allRows: ReportRow[], value: string): ReportRow[] => {
  const searchTerm = value.toLowerCase().trim();
  if (searchTerm === "") {
    return allRows;
  }

  return allRows.filter((row) => rowMatchesSearch(row, searchTerm));
};
